import React from "react";
import {
  createStyles,
  Theme,
  ThemeProvider,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {
  AppBar,
  Avatar,
  ButtonBase,
  Checkbox,
  CssBaseline,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  Paper,
  TextField,
  Toolbar,
  Typography,
} from "@material-ui/core";
import imagePlacholder from "../assets/images/image-placeholder.png";
import AddInspectionDialog from "./AddInspectionDialog";
import CloseIcon from "@material-ui/icons/Close";
import {
  APPLICATION_TYPE,
  CAPTURE_TYPE,
  convertToBoolean,
  getAcronym,
  getCategories,
  getUniqueNames,
  isEmpty,
  WMS_OPERATION_TYPE,
} from "../constants/constants";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { Form, Formik } from "formik";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { defaultTheme } from "../utils/theme";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import arrayMove from "array-move";
import {
  SortableContainer as sortableContainer,
  SortableElement as sortableElement,
} from "react-sortable-hoc";
import RenderImagesDialog from "./RenderImagesDialog";
import { AssetsService } from "../services/AssetsService";
const drawerWidth = "30%";

interface StyledTabProps {
  label: string;
}
interface StyledTabsProps {
  value: number;
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}
const SortableItem = sortableElement((props: any) => {
  let item = props.item;
  let index = props.value;
  return (
    <div
      key={`${index.toString()}-workflow-item`}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <ListItem
        style={{ width: "80%", alignItems: "center", justifyContent: "center" }}
        divider
        button
        onClick={() => {
          props.onOpen(index);
        }}
      >
        <Avatar
          style={{
            width: 25,
            height: 25,
            margin: 10,
            backgroundColor: "orange",
          }}
        >
          <Typography style={{ fontSize: 15 }}>{index + 1}</Typography>
        </Avatar>
        <ListItemText
          primary={`Step name: ${item.stepName ? item.stepName : ""}`}
          secondary={`Step description: ${
            item.stepDescription ? item.stepDescription : ""
          }`}
        />
        <ListItemText
          style={{ marginRight: 20 }}
          primaryTypographyProps={{ align: "right" }}
          secondaryTypographyProps={{
            align: "right",
          }}
          primary={
            item.workflow && item.workflow.name
              ? item.workflow && item.workflow.name
              : ""
          }
          secondary={`${
            item.workflow && item.workflow.inspectionType
              ? item.workflow.inspectionType
              : "obj.workflow.inspectionType"
          } ${
            item.workflow && item.workflow.category
              ? item.workflow.category
              : ""
          }`}
        />
      </ListItem>
      <ListItem style={{ width: "10%" }}>
        <ListItemSecondaryAction
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <IconButton
            style={{
              width: 30,
              height: 30,
              margin: 5,
            }}
            edge="end"
            aria-label="delete"
            onClick={() => {
              props.onEdit(item.workflow, index);
            }}
          >
            <EditIcon fontSize={"small"} />
          </IconButton>
          <IconButton
            style={{
              width: 30,
              height: 30,
              margin: 5,
            }}
            edge="end"
            aria-label="delete"
            onClick={() => {
              props.onDelete(index);
            }}
          >
            <DeleteIcon fontSize={"small"} />
          </IconButton>
          <DragHandleIcon fontSize={"small"} />
        </ListItemSecondaryAction>
      </ListItem>
    </div>
  );
});
const SortableList = sortableContainer((props: any) => {
  return (
    <List component="div">
      {props.items &&
        props.items.map((item: any, index: any) => (
          <SortableItem
            key={`item-key-sort-${index.toString()}`}
            index={index}
            item={item}
            value={index}
            onEdit={props.onEdit}
            onDelete={props.onDelete}
            onOpen={props.onOpen}
          />
        ))}
    </List>
  );
});

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    drawer: {
      [theme.breakpoints.up("sm")]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
      marginTop: 64,
      width: drawerWidth,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    image: {
      width: 128,
      height: 128,
      borderRadius: 10,
    },
    img: {
      "max-width": 120,
      "max-height": 120,
      overflow: "hidden",
    },
  });
interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  handleClose: any;
  handleOnSubmit: any;
  assets: any;
  allLegends: any;
  company: any;
  equipments: any;
  editInspectionData: any;
}
class AddWorkFlowInspectionDialog extends React.Component<Props> {
  state = {
    stepName: "",
    stepDescription: "",
    workflows: new Array<any>(),
    openAddInspectionDialog: false,
    openRenderImagesDialog: false,
    equipmentNames: [],
    images: Array<any>(),
    selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
    editInspectionData: { name: "" },
    editInspectionDataIndex: -1,
    selectedInspectionWorkflowIndex: -1,
    openConfimDelete: false,
    onEditStep: false,
    onEditStepIndex: -1,
  };
  getStepContent = (step: any) => {
    switch (step) {
      case 0:
        return "Select campaign settings...";
      case 1:
        return "What is an ad group anyways?";
      case 2:
        return "This is the bit I really care about!";
      default:
        return "Unknown step";
    }
  };
  componentDidMount = () => {
    this.setState(
      {
        equipmentNames: this.getEquipments(),
        workflows:
          this.props.editInspectionData &&
          this.props.editInspectionData.workflows &&
          this.props.editInspectionData.workflows.length > 0
            ? this.props.editInspectionData.workflows
            : new Array<any>(),
        editInspectionData: {},
      },
      () => {
        this.getInspectionImage();
      }
    );
  };
  componentDidUpdate = async (prevProps: any, prevState: any) => {
    if (prevProps.editInspectionData !== this.props.editInspectionData) {
      if (
        this.props.editInspectionData &&
        !isEmpty(this.props.editInspectionData)
      ) {
        this.setState(
          {
            equipmentNames: this.getEquipments(),
            workflows:
              this.props.editInspectionData &&
              this.props.editInspectionData.workflows &&
              this.props.editInspectionData.workflows.length > 0
                ? this.props.editInspectionData.workflows
                : new Array<any>(),
            editInspectionData: {},
          },
          () => {
            this.getInspectionImage();
          }
        );
      } else {
        this.setState({
          stepName: "",
          stepDescription: "",
          workflows: new Array<any>(),
          openAddInspectionDialog: false,
          openRenderImagesDialog: false,
          equipmentNames: [],
          images: Array<any>(),
          selectedImageItem: { base64: "", item: { filename: "", _id: "" } },
          editInspectionData: { name: "" },
          editInspectionDataIndex: -1,
          selectedInspectionWorkflowIndex: -1,
          openConfimDelete: false,
          onEditStep: false,
          onEditStepIndex: -1,
        });
      }
    }
  };
  getInspectionImage = async () => {
    let imageItem = this.props.editInspectionData.imageItem;
    if (imageItem) {
      let assetsService: AssetsService = new AssetsService();
      this.setState({
        isLoading: true,
      });
      assetsService.getAsset(imageItem.filename).then((resp) => {
        this.setState({
          isLoading: false,
        });
        if (resp && resp.success && resp.data) {
          this.setState({
            selectedImageItem: {
              base64: resp.data,
              item: { filename: imageItem.filename, _id: imageItem._id },
            },
          });
        } else {
          this.setState({
            selectedImageItem: null,
          });
        }
      });
    }
  };

  getImageBase64 = async (imageItem: any) => {
    let assetsService: AssetsService = new AssetsService();
    let resp = await assetsService.getAsset(imageItem.filename);
    if (resp && resp.success && resp.data) {
      return resp.data;
    } else {
      return "";
    }
  };
  renderTextInput = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    selections?: any,
    setFieldValue?: any,
    values?: any
  ) => {
    const { company } = this.props;
    return (
      <div>
        {type === "text" && (
          <TextField
            style={{ margin: 10 }}
            id={id}
            value={value ? value : ""}
            disabled={
              id === "uniquIdentifier" &&
              values.uniquIdentifier === getAcronym(company.name)
                ? true
                : false
            }
            onChange={
              id === "name"
                ? (event: any) => {
                    let nameAcronym = getAcronym(event.target.value);
                    if (values) {
                      let currentUniqueIdentifier = getAcronym(company.name);
                      setFieldValue(
                        "uniquIdentifier",
                        `${currentUniqueIdentifier}${
                          nameAcronym ? "-" + nameAcronym : ""
                        }`
                      );
                    }
                    setFieldValue("name", event.target.value);
                  }
                : handleChange
            }
            onBlur={handleBlur}
            name={name}
            label={label}
            inputProps={id === "phone" ? { maxLength: 10 } : { maxLength: 170 }}
            fullWidth
          />
        )}
        {type === "select" && (
          <TextField
            style={{ margin: 10 }}
            select
            id={id}
            label={label}
            margin="dense"
            value={value ? value : ""}
            onChange={(event) => {
              setFieldValue(id, event.target.value);
            }}
            fullWidth
          >
            {selections.map((option: any, index: any) => (
              <MenuItem key={index.toString()} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}
        <Typography
          variant={"subtitle1"}
          align={"right"}
          style={{
            color: "red",
            alignSelf: "right",
          }}
        >
          {error}
        </Typography>
      </div>
    );
  };
  executeEditInspections = (values: any) => {
    if (this.state.editInspectionDataIndex > -1) {
      let currentWorksflow: any =
        this.state.workflows[this.state.editInspectionDataIndex];
      currentWorksflow.workflow = values;
      let currentWorkflows = this.state.workflows;
      currentWorkflows.splice(
        this.state.editInspectionDataIndex,
        1,
        currentWorksflow
      );
      this.setState({
        workflows: currentWorkflows,
        openAddInspectionDialog: false,
        editInspectionDataIndex: -1,
        editInspectionData: {},
      });
    }
  };
  getEquipments = () => {
    return getUniqueNames(this.props.equipments).map((obj: any) => {
      return {
        label: obj.title,
        value: obj.title.replace(" ", "-").toUpperCase(),
      };
    });
  };
  executeAddInspections = (values: any) => {
    let currentWorksflow: any = this.state.workflows;
    let workflowObj = {
      stepName: this.state.stepName,
      stepDescription: this.state.stepDescription,
      workflow: values,
    };
    currentWorksflow.push(workflowObj);
    this.setState({
      workflows: currentWorksflow,
      openAddInspectionDialog: false,
      stepName: "",
      stepDescription: "",
    });
  };
  renderAddInspectionDialog = (values: any) => {
    let parentValues = Object.assign({}, values);
    let parentData = {
      captureType: parentValues.captureType,
      category: parentValues.category,
      applicationType: parentValues.applicationType,
      operationType: parentValues.operationType,
      equipment: parentValues.equipment,
      equipmentBase: parentValues.equipmentBase,
      frequency: parentValues.frequency,
      inspectionType: parentValues.inspectionType,
      name: this.state.stepName,
      activityflow: parentValues.activityflow,
      breakdown: parentValues.breakdown,
      standing: parentValues.standing,
      fillOnece: parentValues.fillOnce,
      otherValue: parentValues.otherValue,
      roleBase: parentValues.roleBase,
      rolesAssigned: parentValues.rolesAssigned,
      uniquIdentifier: `${getAcronym(
        this.props.company && this.props.company.name
          ? this.props.company.name
          : ""
      )}-${getAcronym(this.state.stepName)}`,
    };
    return (
      <AddInspectionDialog
        open={this.state.openAddInspectionDialog}
        handleClose={() => {
          this.setState({
            openAddInspectionDialog: false,
          });
        }}
        assets={this.props.assets}
        allLegends={this.props.allLegends}
        companyData={this.props.company}
        equipments={this.props.equipments}
        editData={
          this.state.editInspectionData && this.state.editInspectionData.name
            ? this.state.editInspectionData
            : undefined
        }
        parentWorkflowData={
          this.state.editInspectionData && this.state.editInspectionData.name
            ? undefined
            : parentData
        }
        workflows={this.state.workflows}
        handleOnSave={
          this.state.editInspectionData &&
          !isEmpty(this.state.editInspectionData)
            ? this.executeEditInspections
            : this.executeAddInspections
        }
      />
    );
  };

  handleDeleteWorkflowInspection = () => {
    let items = [...this.state.workflows];
    items.splice(this.state.selectedInspectionWorkflowIndex, 1);
    this.setState({
      workflows: items,
      openConfimDelete: false,
    });
  };
  handleOnImageSelected = (imageItem: any) => {
    this.setState({
      openRenderImagesDialog: false,
      selectedImageItem: imageItem,
    });
  };

  renderImagesDialog = () => {
    return (
      <RenderImagesDialog
        open={this.state.openRenderImagesDialog}
        companyData={this.props.company}
        onClose={() => {
          this.setState({
            openRenderImagesDialog: false,
          });
        }}
        onSelectedItem={this.handleOnImageSelected}
        dialogTitle={"Choose Image"}
        images={this.state.images}
      />
    );
  };

  renderConfirmationDialog = () => {
    if (this.state.selectedInspectionWorkflowIndex < 0) {
      return;
    }
    let workflowObj =
      this.state.workflows[this.state.selectedInspectionWorkflowIndex];
    if (!workflowObj) {
      return;
    }
    return (
      <Dialog
        fullWidth={true}
        open={this.state.openConfimDelete}
        onClose={() =>
          this.setState({
            openConfimDelete: false,
            selectedInspectionWorkflowIndex: -1,
          })
        }
      >
        <DialogTitle id="alert-dialog-title">
          {`Deleting ${workflowObj.stepName}`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`Are you sure want to delete this workflow step?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.setState({
                openConfimDelete: false,
                selectedInspectionWorkflowIndex: -1,
              });
            }}
            color="primary"
          >
            No
          </Button>
          <Button
            onClick={() => this.handleDeleteWorkflowInspection()}
            color="primary"
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  onSortEnd = (oldIndex: any, newIndex: any) => {
    let workflows = this.state.workflows;
    let newArray = arrayMove(workflows, oldIndex, newIndex);
    this.setState({
      workflows: newArray,
    });
  };

  render() {
    const {
      title,
      open,
      handleClose,
      handleOnSubmit,
      company,
      editInspectionData,
      classes,
    } = this.props;
    return (
      <React.Fragment>
        <Dialog fullScreen open={open} onClose={handleClose}>
          <DialogTitle id="form-dialog-title">{title}</DialogTitle>
          <Formik
            enableReinitialize={true}
            initialValues={
              editInspectionData && editInspectionData.name
                ? editInspectionData
                : {
                    uniquIdentifier: getAcronym(
                      company && company.name ? company.name : ""
                    ),
                    captureType: "",
                    name: "",
                    frequency: "",
                    inspectionType: "",
                    otherValue: "",
                    category: "",
                    applicationType: "",
                    operationType: "",
                    equipment: "",
                    activityflow: false,
                    breakdown: false,
                    standing: false,
                    headerItems: [],
                    notesItems: [],
                    signotoriesItems: [],
                    inspectionsItems: [],
                    formsItems: [],
                    isDynamic: false,
                    roleBase: false,
                    equipmentBase: false,
                    rolesAssigned: undefined,
                  }
            }
            onSubmit={(values, { resetForm }) => {
              values.workflows = this.state.workflows;
              if (
                this.state.selectedImageItem &&
                this.state.selectedImageItem.item &&
                this.state.selectedImageItem.item.filename
              ) {
                values.imageItem = {
                  filename: this.state.selectedImageItem.item.filename,
                  imageId: this.state.selectedImageItem.item._id,
                };
              }
              let _copy = JSON.parse(JSON.stringify(values));
              this.setState(
                {
                  stepName: "",
                  stepDescription: "",
                  workflows: new Array<any>(),
                  openAddInspectionDialog: false,
                  openRenderImagesDialog: false,
                  equipmentNames: [],
                  images: Array<any>(),
                  selectedImageItem: {
                    base64: "",
                    item: { filename: "", _id: "" },
                  },
                  editInspectionData: { name: "" },
                  editInspectionDataIndex: -1,
                  selectedInspectionWorkflowIndex: -1,
                  openConfimDelete: false,
                  onEditStep: false,
                  onEditStepIndex: -1,
                },
                () => {
                  handleOnSubmit(values);
                  resetForm();
                }
              );
            }}
          >
            {({
              values,
              handleChange,
              handleBlur,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Form>
                <div className={classes.root}>
                  <CssBaseline />
                  {this.renderAddInspectionDialog(values)}
                  <ThemeProvider theme={defaultTheme}>
                    <AppBar position="fixed" className={classes.appBar}>
                      <Toolbar>
                        <IconButton
                          edge="start"
                          color="inherit"
                          onClick={() => {
                            this.setState(
                              {
                                selectedTab: 0,
                                valueVerticalTab: 0,
                              },
                              () => {
                                handleClose();
                              }
                            );
                          }}
                          aria-label="close"
                        >
                          <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                          Add Workflow Inspection
                        </Typography>
                        <Button type="submit" autoFocus color="inherit">
                          Save
                        </Button>
                      </Toolbar>
                    </AppBar>
                  </ThemeProvider>
                  <Drawer
                    className={classes.drawer}
                    variant="permanent"
                    classes={{
                      paper: classes.drawerPaper,
                    }}
                    anchor="left"
                  >
                    <Divider />
                    <div
                      style={{
                        paddingRight: 20,
                        marginBottom: 100,
                        overflow: "auto",
                      }}
                    >
                      <div style={{ padding: 10 }}>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <ButtonBase
                              onClick={() => {
                                this.setState({
                                  openRenderImagesDialog: true,
                                });
                              }}
                              focusRipple={false}
                              className={classes.image}
                            >
                              {this.state.selectedImageItem &&
                              this.state.selectedImageItem.base64 &&
                              !isEmpty(this.state.selectedImageItem.base64) ? (
                                <img
                                  className={classes.img}
                                  alt="complex"
                                  src={`data:image/jpeg;base64,${this.state.selectedImageItem.base64}`}
                                />
                              ) : (
                                <img
                                  className={classes.img}
                                  alt="complex"
                                  src={imagePlacholder}
                                />
                              )}
                              <div
                                style={{
                                  backgroundColor: "orange",
                                  color: "white",
                                  width: "60%",
                                  borderWidth: 1,
                                  borderRadius: 10,
                                  justifyContent: "center",
                                  alignItems: "center",
                                  height: 40,
                                  position: "absolute",
                                  top: 50,
                                  left: 25,
                                }}
                              >
                                <CloudUploadIcon
                                  style={{ width: 15, height: 15 }}
                                />
                                <Typography
                                  style={{
                                    fontSize: 12,
                                    textAlign: "center",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  Upload
                                </Typography>
                              </div>
                            </ButtonBase>
                          </div>
                          {this.renderTextInput(
                            "select",
                            "captureType",
                            values.captureType ? values.captureType : "",
                            handleChange,
                            handleBlur,
                            "captureType",
                            "Capture Type",
                            errors.captureType,
                            CAPTURE_TYPE,
                            setFieldValue
                          )}
                          <FormControlLabel
                            label="Activity Flow Applicable"
                            control={
                              <Checkbox
                                style={{ marginLeft: 10 }}
                                id={"activityflow"}
                                name={"activityflow"}
                                checked={values.activityflow}
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "activityflow",
                                    event.target.checked
                                  );
                                }}
                                value="Passport Number"
                              />
                            }
                          />
                          <FormControlLabel
                            label="Breakdown Report"
                            control={
                              <Checkbox
                                style={{ marginLeft: 10 }}
                                id={"breakdown"}
                                name={"Breakdown"}
                                checked={values.breakdown}
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "breakdown",
                                    event.target.checked
                                  );
                                }}
                                value="Breakdown Report"
                              />
                            }
                          />
                          <FormControlLabel
                            label="Standing Report"
                            control={
                              <Checkbox
                                style={{ marginLeft: 10 }}
                                id={"standing"}
                                name={"Standing"}
                                checked={values.standing}
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "standing",
                                    event.target.checked
                                  );
                                }}
                                value="Standing Report"
                              />
                            }
                          />
                          <FormControlLabel
                            label="Fill Once"
                            control={
                              <Checkbox
                                style={{ marginLeft: 10 }}
                                id={"fillOnce"}
                                name={"fillOnce"}
                                checked={values.fillOnce}
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "fillOnce",
                                    event.target.checked
                                  );
                                }}
                                value="Fill Once"
                              />
                            }
                          />
                          {this.renderTextInput(
                            "text",
                            "uniquIdentifier",
                            values.uniquIdentifier,
                            handleChange,
                            handleBlur,
                            "uniquIdentifier",
                            "Unique Identifier",
                            errors.uniquIdentifier,
                            null,
                            null,
                            values
                          )}
                          {this.renderTextInput(
                            "text",
                            "name",
                            values.name,
                            handleChange,
                            handleBlur,
                            "name",
                            "Inspection Name",
                            errors.name,
                            null,
                            setFieldValue,
                            values
                          )}
                          {this.renderTextInput(
                            "select",
                            "frequency",
                            values.frequency ? values.frequency : "",
                            handleChange,
                            handleBlur,
                            "frequency",
                            "Inspection Frequency",
                            company &&
                              company.inspectionFrequencies &&
                              company.inspectionFrequencies.length > 0
                              ? errors.frequency
                              : "No frequencies added on company level!!",
                            company && company.inspectionFrequencies
                              ? company.inspectionFrequencies
                              : [],
                            setFieldValue
                          )}
                          {this.renderTextInput(
                            "select",
                            "inspectionType",
                            values.inspectionType,
                            handleChange,
                            handleBlur,
                            "inspectionType",
                            "Inspection Type",
                            company &&
                              company.inspectionTypes &&
                              company.inspectionTypes.length > 0
                              ? errors.inspectionType
                              : "No Inspection Types added on company level!!",
                            company && company.inspectionTypes
                              ? company.inspectionTypes
                              : [],
                            setFieldValue
                          )}
                          {values.inspectionType &&
                            this.renderTextInput(
                              "select",
                              "category",
                              values.category ? values.category : "",
                              handleChange,
                              handleBlur,
                              "category",
                              "Inspection Category",
                              errors.category,
                              company && company.inspectionTypes
                                ? getCategories(
                                    company.inspectionTypes,
                                    values.inspectionType
                                  )
                                : [],
                              setFieldValue
                            )}
                          {this.renderTextInput(
                            "select",
                            "applicationType",
                            values.applicationType
                              ? values.applicationType
                              : "",
                            handleChange,
                            handleBlur,
                            "applicationType",
                            "Application Type",
                            errors.applicationType,
                            APPLICATION_TYPE,
                            setFieldValue
                          )}
                          {values.applicationType === "wms" &&
                            this.renderTextInput(
                              "select",
                              "operationType",
                              values.operationType ? values.operationType : "",
                              handleChange,
                              handleBlur,
                              "operationType",
                              "Operation Type",
                              errors.operationType,
                              WMS_OPERATION_TYPE,
                              setFieldValue
                            )}
                          <FormControlLabel
                            label="Equipment Base"
                            control={
                              <Checkbox
                                style={{ marginLeft: 10 }}
                                id={"equipmentBase"}
                                name={"equipmentBase"}
                                checked={
                                  values.equipmentBase
                                    ? Boolean(JSON.parse(values.equipmentBase))
                                    : false
                                }
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "equipmentBase",
                                    event.target.checked
                                  );
                                  setFieldValue("roleBase", false);
                                  setFieldValue("rolesAssigned", []);
                                }}
                                value="Equipment Base"
                              />
                            }
                          />
                          <FormControlLabel
                            label="Role/Position Base"
                            control={
                              <Checkbox
                                style={{ marginLeft: 10 }}
                                id={"roleBase"}
                                name={"roleBase"}
                                checked={
                                  values.roleBase
                                    ? Boolean(JSON.parse(values.roleBase))
                                    : false
                                }
                                onChange={(event: any) => {
                                  setFieldValue(
                                    "roleBase",
                                    event.target.checked
                                  );
                                  setFieldValue("equipmentBase", false);
                                  setFieldValue("equipment", "");
                                }}
                                value="Role/Position Base"
                              />
                            }
                          />
                          {convertToBoolean(values.equipmentBase) &&
                            this.renderTextInput(
                              "select",
                              "equipment",
                              values.equipment,
                              handleChange,
                              handleBlur,
                              "equipment",
                              "Equipment",
                              errors.equipment,
                              this.state.equipmentNames,
                              setFieldValue
                            )}
                          {convertToBoolean(values.roleBase) && (
                            <Autocomplete
                              multiple
                              id="rolesAssigned"
                              options={company.positions}
                              getOptionSelected={(option, value) =>
                                option.label === value.label
                              }
                              getOptionLabel={(option: any) => option.label}
                              defaultValue={
                                values.rolesAssigned ? values.rolesAssigned : []
                              }
                              filterSelectedOptions
                              onChange={(event: any, value: any) => {
                                setFieldValue("rolesAssigned", value);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  label="Select roles"
                                  placeholder="Assign to"
                                />
                              )}
                            />
                          )}
                          {values.inspectionType === "OTHER" &&
                            this.renderTextInput(
                              "text",
                              "otherValue",
                              values.otherValue,
                              handleChange,
                              handleBlur,
                              "otherValue",
                              "Other value",
                              errors.otherValue
                            )}
                        </div>
                      </div>
                    </div>
                  </Drawer>
                  <main className={classes.content}>
                    <div
                      style={{
                        display: "flex",
                        width: "80%",
                        flexDirection: "column",
                      }}
                    >
                      <TextField
                        autoFocus
                        margin="dense"
                        id="stepName"
                        label="Step name"
                        value={this.state.stepName}
                        fullWidth
                        onChange={(event) => {
                          this.setState({
                            stepName: event.target.value,
                          });
                        }}
                      />
                      <TextField
                        autoFocus
                        margin="dense"
                        id="stepDecription"
                        label="Step description"
                        value={this.state.stepDescription}
                        fullWidth
                        onChange={(event) => {
                          this.setState({
                            stepDescription: event.target.value,
                          });
                        }}
                      />
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        {this.state.onEditStep ? (
                          <Button
                            variant="contained"
                            disabled={
                              !this.state.stepName ||
                              !this.state.stepDescription
                                ? true
                                : false
                            }
                            style={{ backgroundColor: "orange" }}
                            onClick={() => {
                              if (this.state.onEditStepIndex > -1) {
                                let currentWorkflow =
                                  this.state.workflows[
                                    this.state.onEditStepIndex
                                  ];
                                currentWorkflow.stepName = this.state.stepName;
                                currentWorkflow.stepDescription =
                                  this.state.stepDescription;
                                let _workflows = this.state.workflows;
                                _workflows.splice(
                                  this.state.onEditStepIndex,
                                  1,
                                  currentWorkflow
                                );
                                this.setState({
                                  workflows: _workflows,
                                  onEditStepIndex: -1,
                                  onEditStep: false,
                                  stepName: "",
                                  stepDescription: "",
                                });
                              }
                            }}
                          >
                            Save Inspection
                          </Button>
                        ) : (
                          <Button
                            variant="contained"
                            disabled={
                              !this.state.stepName ||
                              !this.state.stepDescription
                                ? true
                                : false
                            }
                            style={{ backgroundColor: "orange" }}
                            onClick={() => {
                              this.setState({
                                openAddInspectionDialog: true,
                                editInspectionData: {},
                              });
                            }}
                          >
                            Capture Step Inspection
                          </Button>
                        )}
                      </div>
                      <Paper>
                        <SortableList
                          items={this.state.workflows}
                          onSortEnd={(props: any) =>
                            this.onSortEnd(props.oldIndex, props.newIndex)
                          }
                          pressDelay={200}
                          onEdit={(workflow: any, index: any) => {
                            this.setState({
                              editInspectionData: workflow,
                              editInspectionDataIndex: index,
                              openAddInspectionDialog: true,
                            });
                          }}
                          onDelete={(index: any) => {
                            this.setState({
                              openConfimDelete: true,
                              selectedInspectionWorkflowIndex: index,
                            });
                          }}
                          onOpen={(index: any) => {
                            let currentWorkflow = this.state.workflows[index];
                            this.setState({
                              stepName: currentWorkflow.stepName,
                              stepDescription: currentWorkflow.stepDescription,
                              onEditStep: true,
                              onEditStepIndex: index,
                            });
                          }}
                        />
                      </Paper>
                    </div>
                  </main>
                </div>
              </Form>
            )}
          </Formik>
        </Dialog>
        {this.renderConfirmationDialog()}
        {this.renderImagesDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddWorkFlowInspectionDialog);
